
export default {
  props: {
    stats: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      statOrder: [`mins_played`, `yellow_cards`, `red_cards`],
    };
  },
  methods: {
    getIcon (key) {
      if (key === `mins_played`) {
        return `icon-stopwatch`;
      }
      return key.replace(`_`, `-`);
    },
  },
};
